// extracted by mini-css-extract-plugin
module.exports = {"root":"TextModule_root__3eNAA","container":"TextModule_container__2wsAt","eyebrow":"TextModule_eyebrow__2AOAl","text":"TextModule_text__3yHUm","cutoff":"TextModule_cutoff__2YrcZ"};